import api from './api';

const newKey = () => (window.crypto?.randomUUID ? window.crypto.randomUUID() : `${Date.now()}-${Math.random()}`);

export const coopPlatformService = {
  list: (params) => api.get('/coop-platform/societies/', { params }),
  get: (id) => api.get(`/coop-platform/societies/${id}/`),
  create: (data) => api.post('/coop-platform/societies/', data, { headers: { 'Idempotency-Key': newKey() } }),
  update: (id, data) => api.patch(`/coop-platform/societies/${id}/`, data),
  action: (id, action, data = {}) => api.post(`/coop-platform/societies/${id}/${action}/`, data),
  branding: (id) => api.get(`/coop-platform/societies/${id}/branding/`),
  updateBranding: (id, data) => api.put(`/coop-platform/societies/${id}/branding/`, data),
  uploadLogo: (id, filename, contentBase64) =>
    api.put(`/coop-platform/societies/${id}/branding/logo/`, { filename, content_base64: contentBase64 }),
  auditEvents: (id) => api.get(`/coop-platform/societies/${id}/audit-events/`),
  checkSlug: (slug) => api.get('/coop-platform/slug-availability/', { params: { slug } }),
  plans: () => api.get('/coop-platform/plans/'),
};
